// extracted by mini-css-extract-plugin
export default {"circle":"UPI_circle__9rNA8","firstName":"UPI_firstName__5Bh+K","container":"UPI_container__eXTxz"};